import KeenSlider from "keen-slider";

export default class Slider {
    private readonly sliderElement: HTMLElement;
    private readonly leftArrow: HTMLElement;
    private readonly rightArrow: HTMLElement;

    constructor(sliderElement: HTMLElement) {
        this.sliderElement = sliderElement;
        this.leftArrow = document.querySelector('.arrow--left') as HTMLButtonElement;
        this.rightArrow = document.querySelector('.arrow--right') as HTMLButtonElement;
        this.init();
    }

    private init() {
        if (this.sliderElement) {
            const slider = new KeenSlider(this.sliderElement, {
                loop: true,
            },
                [
                    (slider) => {
                        let timeout
                        let mouseOver = false
                        function clearNextTimeout() {
                            clearTimeout(timeout)
                        }
                        function nextTimeout() {
                            clearTimeout(timeout)
                            if (mouseOver) return
                            timeout = setTimeout(() => {
                                slider.next()
                            }, 10000)
                        }
                        slider.on("created", () => {
                            nextTimeout()
                        })
                        slider.on("dragStarted", clearNextTimeout)
                        slider.on("animationEnded", nextTimeout)
                        slider.on("updated", nextTimeout)
                    },
                ]
            );

            if (this.leftArrow && this.rightArrow) {
                // Add click event listeners
                this.leftArrow.addEventListener('click', () => slider.prev());
                this.rightArrow.addEventListener('click', () => slider.next());
            }

            window.onload = () => {
                document.querySelectorAll('.flip-card-back').forEach((item) => {
                    adjustFontSize(item)
                })
            }

            let resizeTimeout;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimeout);

                resizeTimeout = setTimeout(() => {
                    document.querySelectorAll('.flip-card-back').forEach((item) => {
                        adjustFontSize(item)
                    })
                }, 250);
            });
        }

        function adjustFontSize(backCard) {
            const text = backCard.querySelector('.text') as HTMLElement;
            let fontSize = window.innerWidth > 768 ? 35 : 20;

            // Setze die Schriftgröße auf die Anfangsgröße
            text.style.fontSize = fontSize + 'px';
            // Schleife, um die Schriftgröße zu verringern, bis der Text in den Container passt
            while (text.scrollHeight > backCard.offsetHeight && fontSize > 12) { // Begrenze die Mindestgröße auf 5px
                fontSize--;
                text.style.fontSize = fontSize + 'px';
            }
        }
    }
}